import { BuildUrl } from "../../helpers";
import { DoctorImageSasToken } from "../../models";
import { PendingDoctorImage } from "./DoctorForm";

export const saveDoctorImage = async (
	doctorId: number,
	image: PendingDoctorImage,
	headers: HeadersInit
) => {
	if (!image) return;
	const tokenResponse = await fetch(BuildUrl("DoctorImages/sas-token"), {
		headers
	});
	if (!tokenResponse.ok)
		throw new Error("Could not retrieve image access token");
	const { containerUrl, sasToken }: DoctorImageSasToken =
		await tokenResponse.json();
	if (!containerUrl || !sasToken) throw new Error("Missing image access token");
	const query = sasToken.startsWith("?") ? sasToken : `?${sasToken}`;
	const imageUrl = (extension: string) =>
		`${containerUrl}/${doctorId}.${extension}${query}`;
	const deleteImage = async (extension: string) => {
		const result = await fetch(imageUrl(extension), { method: "DELETE" });
		if (!result.ok && result.status !== 404)
			throw new Error("Could not delete doctor image");
	};
	if (image === "delete") {
		await deleteImage("jpg");
		await deleteImage("png");
	} else {
		const extension = image.type === "image/png" ? "png" : "jpg";
		const result = await fetch(imageUrl(extension), {
			method: "PUT",
			headers: { "x-ms-blob-type": "BlockBlob", "Content-Type": image.type },
			body: image
		});
		if (!result.ok) throw new Error("Could not upload doctor image");
		await deleteImage(extension === "png" ? "jpg" : "png");
	}
	const result = await fetch(
		BuildUrl("DoctorImages/DeleteCachedDoctorImages"),
		{
			method: "POST",
			headers,
			body: JSON.stringify([doctorId])
		}
	);
	if (!result.ok) throw new Error("Could not clear cached doctor image");
};
